<template>
<div :class="`card ${isDebug ? 'add-border':''}`" data-tipo-componente="componente-tipo-resposta-texto">
    <!-- Card content -->
    <div class="card-body">
      <!-- Title -->
      <div class="row">
        <div class="col-md-11">
          <h6 class="card-title">
            <a>{{ pergunta.ordemExibicao}} ) {{ pergunta.titulo }}</a>
            <span
              v-if="pergunta.obrigatoria"
              style="color: red; font-weight: bold"
              >*</span
            >
          </h6>
          <p v-if="pergunta.subTitulo">
            <small>{{pergunta.subTitulo}}</small>
          </p>
        </div>
        <div class="col">
          <!-- <span class="badge badge-success" style="float:rigth"><i class="bi bi-check"></i></span> -->
        </div>
      </div>
      <h6>
        <small v-if="pergunta.subTitulo" class="text-muted">
          {{ pergunta.subTitulo }}
        </small>
      </h6>
      <!-- Text -->
      <p class="card-text" v-if="pergunta.descricao" v-html="pergunta.descricao"></p>
      <div class="container2">
        <div class="row">
          <!--opcoes de resposta -->
          <div class="col-md-12">
            <div class="form-group">
              <input
                blur="validarResposta"
                @blur="onBlurInputHandler"
                :required="pergunta.obrigatoria"
                placeholder=""
                class="form-control input-sm col-md-10"
                type="text"
                :id="'txtText_' + pergunta.perguntaId"
                name="txtText_"
                v-model="resposta"
              />
            </div>

            <ul v-if="temErro" class="alert alert-sm alert-danger">
              <li :key="index" v-for="(erro, index) in erros">
                {{ `- ${erro}` }}
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import repostaPerguntaMethodsMixin from "./ResponderPerguntaMixin";
export default {
  mixins: [repostaPerguntaMethodsMixin],
  name: "comp-pergunta-texto",
  props: ["pergunta", "permitirResponder", "formulario"],
  data() {
    return {
      resposta: "",
      temErro: false,
      avisoErro: "",
      erros: []
    };
  },
  computed: {
    botaoDesabilitado() {
      return this.resposta === "" || !this.permitirResponder;
    },
  },
  methods: {
    onBlurInputHandler(e){

        this.validarResposta();
        this.aplicarValidacaoPorValorMixin();

    },
    async validarResposta() {

      this.erros = [];
      const pergunta = this.pergunta;
      const { perguntaId,  sessaoFormularioPerguntaId} = this.pergunta;
      const opcaoResposta = {
        opcaoResposta: {
          opcaoRespostaId: null,
          perguntaId,
          sessaoFormularioPerguntaId,
          valor: this.resposta,
        },
        pergunta,
      };


      if (this.pergunta.obrigatoria && !this.resposta) {
        this.erros.push("Você deve responder esta pergunta.");
      }else {
         //remover o valor de resposta anterior
        this.removerTodasRespostasPergunta(sessaoFormularioPerguntaId);
      }


      // this.temErro = this.pergunta.obrigatoria && !this.resposta
      this.temErro = this.erros.length > 0;
      if (this.temErro) {
        this.avisoErro = this.erros[0];
      } else {
        this.responderPerguntaMixin(opcaoResposta);
      }
    },
  },
  mounted() {
    
    const {perguntasRespondidas} = this.$store.state;
    const {perguntaId} = this.pergunta;
    if(perguntasRespondidas && perguntasRespondidas.length) {
        const [perguntaRespondida] = perguntasRespondidas.filter(p=>p.perguntaId == perguntaId);
        if(perguntaRespondida){
          const {respostas} = perguntaRespondida;
          if(respostas && respostas.length) {
            this.resposta = respostas[0].valor;
          }
        }
    }

    if(this.isDebug){
      console.log('init tipo texto', this.pergunta.titulo);
      console.log('perguntaId', perguntaId)
    }
  
  },
};
</script>

<style scoped>
ul {
  list-style: none;
}

.add-border {
    border:2px solid blue;
  }

</style>



// WEBPACK FOOTER //
// src/components/PerguntasComponent/RespostaTipoTexto.vue